import { useEffect } from 'react'
import { useSearchParams } from 'react-router'
import { useListSquareIntegrationsQuery } from '@/state/neo/neo-square-auth.api'

/**
 * Shared selection state for the Square entity (merchant account) pickers in the
 * top bar (new-UI + old-UI variants). The selected entity lives in the `?entity`
 * query param so the Discounts page reads the same source of truth. Defaults to
 * the first connected entity.
 */
export function useSquareEntitySelection(orgId: string) {
  const [params, setParams] = useSearchParams()
  const { data } = useListSquareIntegrationsQuery(
    { organizationId: orgId },
    { skip: !orgId }
  )
  const integrations = data?.integrations ?? []
  const currentParam = params.get('entity') ?? ''

  useEffect(() => {
    if (!currentParam && integrations.length) {
      const next = new URLSearchParams(params)
      next.set('entity', integrations[0].id)
      setParams(next, { replace: true })
    }
  }, [currentParam, integrations, params, setParams])

  const selected =
    integrations.find((i) => i.id === currentParam) ?? integrations[0] ?? null

  function select(id: string) {
    const next = new URLSearchParams(params)
    next.set('entity', id)
    setParams(next, { replace: true })
  }

  return { integrations, selected, select }
}
